import { render, staticRenderFns } from "./AgentChatbox.vue?vue&type=template&id=4fda354b&scoped=true"
import script from "./AgentChatbox.vue?vue&type=script&lang=ts"
export * from "./AgentChatbox.vue?vue&type=script&lang=ts"
import style0 from "./AgentChatbox.vue?vue&type=style&index=0&id=4fda354b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda354b",
  null
  
)

export default component.exports